export const CLOUD_NAME = "dewxptj1i";
export const UPLOAD_PRESET = "ShreejiSurtiSwad";
